export default () => {
  return {
    categories: [],
    customCategories: []
  }
}
